import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    site: {
      name: 'LeaserTech',
      description: 'Elektronik ürünler için güvenilir alışveriş',
      currency: 'TRY',
      language: 'tr'
    },
    shipping: {
      freeShippingThreshold: 300,
      defaultShippingCost: 50,
      expressShippingCost: 249,
      estimatedDeliveryDays: 3
    }
  });
  const [loading, setLoading] = useState(true);

  const loadSettings = useCallback(async () => {
    try {
      setLoading(true);
      
      // Önce localStorage'dan yükle (hızlı yükleme için)
      const cachedSettings = localStorage.getItem('siteSettings');
      if (cachedSettings) {
        try {
          setSettings(JSON.parse(cachedSettings));
          setLoading(false); // Cache'den yüklendi, loading'i false yap
        } catch (e) {
          // Cache bozuksa devam et
        }
      }

      // API'den güncel ayarları al (hata olsa bile devam et)
      try {
        const response = await api.get('/settings');
        const newSettings = response.data;
        setSettings(newSettings);
        
        // localStorage'a kaydet
        localStorage.setItem('siteSettings', JSON.stringify(newSettings));
      } catch (apiError) {
        // API hatası sessizce görmezden gel, cache varsa onu kullan
        if (!cachedSettings) {
          // Cache yoksa varsayılan ayarları kullan
          console.warn('Ayarlar API\'den yüklenemedi, varsayılan ayarlar kullanılıyor');
        }
      }
    } catch (error) {
      // Genel hata durumunda sessizce devam et
      console.warn('Ayarlar yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const updateSettings = (newSettings) => {
    setSettings(newSettings);
    localStorage.setItem('siteSettings', JSON.stringify(newSettings));
  };

  useEffect(() => {
    loadSettings();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const value = {
    settings,
    loading,
    loadSettings,
    updateSettings
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
